import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import {
  StyledItem,
  Info,
  ColorCircle,
  SquareButton,
  ButtonsWrapper,
  SettingItemIcon
} from './StyledComponents';

const SettingItem = ({ item, editItem, deleteItem }) => {
  const dispatch = useDispatch();

  return(
    <StyledItem>
      <Info>
        <ColorCircle color={item.color}/>
        {item.label || item.name}
      </Info>
      <ButtonsWrapper>
        <SquareButton
          onClick={(e) => editItem()}
        >
          <SettingItemIcon className='fa-light fa-pencil' />
        </SquareButton>
        <SquareButton
          onClick={(e) => {
            deleteItem(item)
          }}
        >
          <SettingItemIcon className='fa-light fa-trash-can' />
        </SquareButton>
      </ButtonsWrapper>
    </StyledItem>
  )
};

export default SettingItem;
